/**
 * 1stdibs
 * User: James
 * Date: 1/25/13
 */
"use strict";

var SoaCollection = require('bunsen/collections/SoaCollection');
var _ = require('underscore');
var endpoints = require('dibs-endpoints');
var ItemCreator = require('bunsen/models/link-models/ItemCreator');
var ItemCreators = module.exports = SoaCollection.extend();

_.extend(ItemCreators.prototype, {
    model: ItemCreator,
    item_id: null,
    url : endpoints.creatorList(),
    parse: function (data) {
        if (data && data.result && data.result.creatorList) {
            return data.result.creatorList;
        }
        return ItemCreators.__super__.parse.call(this, data);
    },
    initialize : function () {
        this.item_id = this.item_id || (this.options && this.options.item_id) ? this.options.item_id : null;
    },
    /**
     * Replaces native fetch. Simply just adds the item id to the url before
     * it calls and returns the native backbone fetch.
     * @param options
     * @return {*}
     */
    fetch : function (options) {
        options = options || {};
        var iid = options.item_id || this.item_id;

        this.url = this.url + '/' + iid;
        return this.constructor.__super__.fetch.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/ItemCreators.js
// module id = 1619
// module chunks = 64